import React from "react";
import { Sparkles, Layers, Compass } from "lucide-react";

// Generic 3-tier complexity display used on the Services page and the
// "So funktioniert's" overview. Pass `service` (label) and `tiers` array:
//   [{ key, label, summary, bullets:[], effort }]
// Optionally `intro` text.
export default function ComplexityTiers({ service, intro, tiers, testIdPrefix }) {
  const meta = {
    einfach:  { Icon: Sparkles, accent: "#16A34A", bg: "bg-emerald-50",  text: "text-emerald-700",  ring: "ring-emerald-200" },
    standard: { Icon: Layers,   accent: "#1A2433", bg: "bg-slate-50",    text: "text-slate-700",    ring: "ring-slate-200" },
    komplex:  { Icon: Compass,  accent: "#991B1B", bg: "bg-red-50",      text: "text-[#991B1B]",    ring: "ring-red-200" },
  };

  return (
    <div className="grid gap-4 md:gap-5 md:grid-cols-3" data-testid={`${testIdPrefix}-tiers`}>
      {tiers.map((t) => {
        const m = meta[t.key] || meta.standard;
        const Icon = m.Icon;
        return (
          <div
            key={t.key}
            className={`relative ${m.bg} ring-1 ${m.ring} rounded-xl p-6 flex flex-col`}
            data-testid={`${testIdPrefix}-tier-${t.key}`}
          >
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: m.accent }}
              >
                <Icon className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className={`text-[10px] uppercase tracking-[0.18em] font-semibold ${m.text}`}>{t.label}</div>
                <div className="font-heading text-lg font-bold text-[#1A2433] leading-tight">{t.summary}</div>
              </div>
            </div>

            <ul className="space-y-2 mb-4 flex-1">
              {t.bullets.map((b, i) => (
                <li key={i} className="text-sm text-slate-600 leading-snug flex gap-2">
                  <span className="mt-1.5 w-1 h-1 rounded-full bg-slate-400 flex-shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            {t.effort && (
              <div className="text-xs text-slate-500 border-t border-slate-200/70 pt-3 mt-auto">
                <span className="font-semibold text-[#1A2433]">Typischer Aufwand:</span> {t.effort}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
